import ViewNewsLetterSubscribers from "../components/news-letter-subscribers/ViewNewsLetterSubscribers";

export default function NewsLetterSubscribersPage() {
  return <ViewNewsLetterSubscribers />;
}
